import { theme } from 'lib';
import styled from 'styled-components';

// Shared card chrome for the rotating Team Channel slot (poll / quiz / placeholder).
export const SurfaceCard = styled.div`
  width: 100%;
  border: 1px solid ${theme.GREY_20};
  border-radius: 14px;
  background: #fff;
  padding: 18px 20px 20px;
`;

// --- Poll option + results bar (lifted from Polls/PollViewModal) -------------------------
export const BarTrack = styled.div`
  width: 100%;
  height: 10px;
  border-radius: 999px;
  background: ${theme.GREY_10};
  overflow: hidden;
  margin-top: 6px;
`;

export const BarFill = styled.div`
  height: 100%;
  border-radius: 999px;
  width: ${(p) => p.pct}%;
  background: ${(p) => (p.winner ? theme.GREEN : theme.SECONDARY)};
  transition: width 0.3s ease;
`;

export const OptionRow = styled.button`
  width: 100%;
  text-align: left;
  border: 1px solid ${(p) => (p.selected ? theme.SECONDARY : theme.GREY_20)};
  background: ${(p) => (p.selected ? `${theme.SECONDARY}10` : '#fff')};
  border-radius: 10px;
  padding: 12px 14px;
  cursor: ${(p) => (p.interactive ? 'pointer' : 'default')};
  font-family: CeraPro;
`;

export const RadioDot = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid ${(p) => (p.selected ? theme.SECONDARY : theme.GREY_30)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  &::after {
    content: '';
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: ${(p) => (p.selected ? theme.SECONDARY : 'transparent')};
  }
`;

// --- Quiz answer option + result banner (lifted from QuickQuiz/QuizPlayModal) ------------
export const Option = styled.button`
  width: 100%;
  text-align: left;
  border: 1.5px solid
    ${(p) =>
      p.state === 'correct'
        ? theme.GREEN
        : p.state === 'wrong'
          ? theme.SECONDARY
          : p.selected
            ? theme.SECONDARY
            : theme.GREY_20};
  background: ${(p) =>
    p.state === 'correct'
      ? `${theme.GREEN}12`
      : p.state === 'wrong'
        ? `${theme.SECONDARY}10`
        : p.selected
          ? `${theme.SECONDARY}08`
          : '#fff'};
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 10px;
  font-family: CeraPro;
  font-size: 14px;
  color: ${theme.GREY_90};
  cursor: ${(p) => (p.disabled ? 'default' : 'pointer')};
  display: flex;
  align-items: center;
  gap: 12px;
  transition: border-color 0.15s ease, background 0.15s ease;
`;

export const Radio = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1.5px solid
    ${(p) =>
      p.state === 'correct'
        ? theme.GREEN
        : p.state === 'wrong'
          ? theme.SECONDARY
          : p.selected
            ? theme.SECONDARY
            : theme.GREY_30};
  background: ${(p) =>
    p.state === 'correct' ? theme.GREEN : p.state === 'wrong' ? theme.SECONDARY : 'transparent'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 18px;
`;

export const ResultBanner = styled.div`
  background: ${(p) => (p.correct ? `${theme.GREEN}15` : `${theme.SECONDARY}10`)};
  border: 1px solid ${(p) => (p.correct ? theme.GREEN : theme.SECONDARY)};
  border-radius: 10px;
  padding: 14px 16px;
  margin: 0 0 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
